import { render, staticRenderFns } from "./PaymentMethodsView.vue?vue&type=template&id=d031a364&scoped=true&"
import script from "./PaymentMethodsView.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d031a364",
  null
  
)

export default component.exports